import React from 'react'

const ScrollTop = () => {
  return (
    <div style={{ color:"rgb(93 53 201)", fontSize: "3rem" }} >
        <i class="fa-solid fa-circle-arrow-up"></i>
        
    </div>
  )
}

export default ScrollTop